import { Autocomplete, CircularProgress, TextField } from "@mui/material";

import { AssignableOwner } from "@hooks/useAssignableOwners";
import { formatFullName } from "@helpers/generals";

interface AutocompleteSlotProps {
    input?: { endAdornment?: React.ReactNode } & Record<string, unknown>;
    [key: string]: unknown;
}

export const getOwnerLabel = (user: AssignableOwner, showEmail: boolean = false) => {
    const fullName = formatFullName(user);
    return showEmail && user.email ? `${fullName} (${user.email})` : fullName;
};

interface OwnerAutocompleteInputProps {
    open?: boolean;
    onOpen?: () => void;
    onClose?: () => void;
    loading: boolean;
    options: Array<AssignableOwner>;
    value: AssignableOwner | null;
    onChange: (value: AssignableOwner | null) => void;
    showEmail?: boolean;
}

export const OwnerAutocompleteInput = ({
    open,
    onOpen,
    onClose,
    loading,
    options,
    value,
    onChange,
    showEmail = false,
}: OwnerAutocompleteInputProps) => (
    <Autocomplete
        size="small"
        fullWidth
        open={open}
        loading={loading}
        onOpen={onOpen}
        onClose={onClose}
        options={options}
        value={value}
        onChange={(_, selected) => onChange(selected)}
        getOptionLabel={(user) => getOwnerLabel(user, showEmail)}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        noOptionsText="Sin usuarios configurados para esta etapa"
        renderInput={(params) => {
            const autoSlotProps = (params as { slotProps?: AutocompleteSlotProps }).slotProps;
            return (
                <TextField
                    {...params}
                    label="Usuario"
                    slotProps={{
                        ...autoSlotProps,
                        input: {
                            ...autoSlotProps?.input,
                            endAdornment: (
                                <>
                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {autoSlotProps?.input?.endAdornment}
                                </>
                            ),
                        },
                    }}
                />
            );
        }}
    />
);
